import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const state = {
    navindex: 0
}


export default new Vuex.Store({
    state,
    mutations: {
        setIndex(state, token) {
            state.navindex = token
        },
       
    },
})


// WEBPACK FOOTER //
// ./src/store/index.js